import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Badge from './Badge';

const BadgeLabel = (props) => {
	const {label, value, variant} = props;

	return (
		<StyledBadgeLabel>
			<span className={'badge-label'} title={label}>
				{label}
			</span>
			<Badge variant={variant} value={value} />
		</StyledBadgeLabel>
	);
};

BadgeLabel.defaultProps = {
	label: '',
	value: 0
};

BadgeLabel.propTypes = {
	label: PropTypes.string,
	value: PropTypes.number
};

export default BadgeLabel;

const StyledBadgeLabel = styled.div`
	font-weight: normal;
	font-size: 1.2rem;
	display: flex;
	min-width: 0;
	.badge-label {
		margin-right: 1rem;
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.motif-badge {
		min-width: 2.4rem;
		background: ${(props) => props.theme.color[`grey500`]};
		color: ${(props) => props.theme.color[`white`]};
	}
`;
